import { FC, useState } from "react"
import { Dialog } from 'primereact/dialog';
import './edittransportemodaldialog.css'
import { Button } from "primereact/button";
import { MdEdit, MdOutlineCancel } from "react-icons/md";
import { InputText } from "primereact/inputtext";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { InputNumber } from "primereact/inputnumber";

export const EditTransporteModalDialog:FC<any> = (props):JSX.Element => {

    const { data, setData, dataMASTER, visible, selectedCell, selectedRow, setSelectedRow, handleClose, mode, type } = props 

    const handleUpdateDataTransportePKM = () => {
        let original = dataMASTER.precio_km_table.find((ori:any) => ori.km === selectedRow.km)?.[selectedCell]
        
        let aux = data?.precio_km_table

        let precio_km_table = aux.map((a:any) => {
            if(a.km === selectedRow?.km) {
                return {...selectedRow, edited: original != selectedRow?.[selectedCell]? true : false}
            }
            return a
        })
        
        setData({...data,precio_km_table:precio_km_table})
        handleClose()
    }

    const handleUpdateDataTransporteIE = () => {
        let original = dataMASTER.inflacion_esperada_table.find((ori:any) => `${ori.anio}${ori.mes}` === `${selectedRow.anio}${selectedRow.mes}`)?.[selectedCell]
        let aux = data?.inflacion_esperada_table

        let inflacion_esperada_table = aux.map((a:any) => {
            if(`${a.anio}${a.mes}` === `${selectedRow?.anio}${selectedRow?.mes}`) {
                return {...selectedRow, edited: original != selectedRow?.[selectedCell]? true : false}
            }
            return a
        })
        
        setData({...data,inflacion_esperada_table:inflacion_esperada_table})
        handleClose()
    }

    const renderLabel = () => {
        let field_array = selectedCell?.split("_")
        field_array?.pop()
        
        let header_title = field_array?.map((word:string,index:number) => {
            if(index === 0) {
                return word.charAt(0).toUpperCase() + word.slice(1)
            }
            return word
        }).join(' ')

        return header_title
    }

    const header = () => {
        return (
            <span>Ajuste de parámetros</span>
        )
    }

    const footer = () => {
        return (
            <div className="scenarios-footer">
                <Button severity={'success'} label="Actualizar" icon={<MdEdit style={{fontSize:20}} />}  onClick={type === 'PKM' ? handleUpdateDataTransportePKM : handleUpdateDataTransporteIE} outlined  />
                <Button severity={'danger'} label="Cancelar" icon={<MdOutlineCancel style={{fontSize:20,marginRight:5}} />}  outlined onClick={handleClose} />
            </div>
        )
    }

    const handleChangeValue = (e:any) => {
        const { value } = e
        setSelectedRow({...selectedRow,[selectedCell]:parseFloat(value)})
    }

    return (
        <div className="card flex justify-content-center">
            <Dialog className={mode === 'base'? "edit-modal-dialog-base" : mode === 'comparision' ? "edit-modal-dialog-compare" : "edit-modal-dialog-neutral"} header={header} visible={visible} style={{ width: '25vw' }} footer={footer} onHide={handleClose}>
                <div style={{minHeight:85,display:'flex',justifyContent:'center',alignItems:'center',padding:'1rem'}}>
                    <div className="card flex justify-content-center" style={{width:'95%'}}>
                        <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor={"error-name"}>{renderLabel()}</label>
                        <div className="permisos__header-input">
                            <InputNumber inputMode="decimal" minFractionDigits={2} style={{width:'100%'}} id={"error-name"} className="scenario-inputs" onChange={handleChangeValue}  value={selectedRow?.[selectedCell] ?? 0 }    />

                            <span className="p-inputgroup-addon" >
                                <HiOutlinePencilSquare style={{fontSize:20}} />
                            </span>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}